import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageFilterComponent } from './page-filter.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { FilterModule } from '@gspwidget/widget-core';
import { XcHelp2Module } from '@gspwidget/util';

@NgModule({
  declarations: [PageFilterComponent],
  imports: [
    CommonModule,
    NzDropDownModule,
    FilterModule,
    XcHelp2Module,
  ],
  exports: [PageFilterComponent],
})
export class PageFilterModule { }
